// CENTRALIZED PROMO TOGGLE CONTROL
// Set to true to enable both promotional banner and promos section
// Set to false to disable both promotional banner and promos section
// Last updated: 2025-12-02 - Automated deployment test
export const PROMO_FEATURES_ENABLED = false;

// This single switch controls:
// 1. Promotional banner (scrolling bar at top)
// 2. Promos section (between Testimonials and Contact)
// 3. Promo menu item visibility
// 4. Menu bar positioning (adjusts when banner is disabled)